export default {
  confirmOrder: 'Confirmar pedido',
  createSuccess: 'Pedido creado con éxito',
  orderPrice: 'Precio total del pedido',
  otherAction: 'Otras acciones',
  orderStatus: 'Estado del pedido',
  afterSales: 'Servicio postventa',
  allSelect: 'Seleccionar todo',
  orderNo: 'Número de pedido',
  createTime: 'Hora de creación',
  productRemark: 'Información de nota del producto',
  productRemarkHolder:
    'Mensaje para el agente de compras. Si no hay requisitos de compra especiales, no lo rellene.',
  orderDetail: 'Detalles del pedido',
  goPay: 'Pago',
  cancelpay: 'Cancelar el pago',
  cancelPay: '¿Cancelar el pago?',
  cancelOrder: '¿Cancelar el pedido?',
  cancelorder: 'Cancelar el pedido',
  cancelOrderProduct: '¿Cancelar el producto?',
  cancelorderProduct: 'Cancelar el producto',
  cancelPayResultHint:
    'Después de la cancelación, no se puede restaurar el pago. Por favor, seleccione la razón para cancelar el pago.',
  cancelOrderResultHint:
    'Después de la cancelación, no se puede restaurar el pedido. Por favor, rellene la razón para cancelar el pedido.',
  delOrder: 'Eliminar pedido',
  delOrderHint:
    '¿Está seguro de que desea eliminar el pedido? Si el producto ha sido reembolsado, el artículo no se devolverá al vendedor para el reembolso.',
  cancelSuccess: 'Cancelación exitosa',
  delSuccess: 'Eliminación exitosa',
  orderBin: 'Papelera de reciclaje',
  backOrder: 'Volver a mis pedidos',
  restoreOrder: 'Restaurar pedido',
  remark: 'Observaciones',
  all: 'Todo',
  productName: 'Nombre del producto',
  submitTime: 'Hora de envío',
  orderConsult: 'Consulta de pedido',
  appendService: 'Servicio adicional',
  iKnow: 'Entendido',
  cancelReturnBag: 'Cancelar devolución y cambio',
  isCancelApply: '¿Está seguro de que desea cancelar la solicitud?',
  cancelBackTax: 'Cancelar el pago adicional',
  productAttr: 'Atributos del producto',
  backTaxType: 'Tipo de pago adicional',
  taxPrice: 'Precio del pago adicional',
  productBackTax: 'Pago adicional del producto',
  freightBackTax: 'Pago adicional del flete',
  productTaxPrice: 'Precio del pago adicional del producto',
  freightTaxPrice: 'Precio del pago adicional del flete',
  totalTaxPrice: 'Precio total del pago adicional',
  productStatus: 'Estado del producto',
  isNeedTax: '¿Se necesita pago adicional?',
  yes: 'Sí',
  no: 'No',
  iThinkAbout: 'Lo pensaré',
  revokeCheckedProduct: 'Revocar producto seleccionado',
  taxTips1:
    'Por favor, [Pagar adicional] o [Cancelar] lo antes posible para no afectar la compra de otros productos en el pedido.',
  cancelTaxTips1:
    'Si no está dispuesto a pagar el adicional, no podremos comprar el producto que requiere un pago adicional.',
  cancelTaxTips2:
    'Los productos marcados se cancelarán después de la revocación y el costo del producto se reembolsará a su cuenta.',
  cancelTaxTips3: 'Los productos no marcados se mantendrán y continuaremos comprando por usted.',
  cancelReason: {
    0: 'No quiero comprarlo',
    1: 'Información rellenada incorrectamente',
    2: 'El vendedor no tiene stock',
    3: 'No puedo pagar',
    4: 'Otras razones',
    5: 'Riesgo de marca',
  },
  hint: 'Pista',
  orderStatusEnum: {
    0: 'Pendiente de pago',
    1: 'Sin procesar',
    2: 'En revisión',
    3: 'Pedido transferido',
    4: 'Pedido cancelado',
    5: 'Pago adicional del flete',
    6: 'Revisión de control de riesgos',
    7: 'Pedido revocado',
    8: 'Pago en progreso',
    9: 'Completado',
  },
  returnGood: {
    name: 'Devolución/Cambio',
    selectType: 'Seleccionar tipo',
    returnGood: 'Devolución',
    returnDayTips: 'Por lo general, tarda de 7 a 15 días',
    changeGood: 'Cambio',
    changeDayTips: 'Por lo general, tarda de 7 a 20 días',
    returnReasonEnum: {
      0: 'Compré mal/No me gusta',
      1: '¿El vendedor envió el producto equivocado?',
      2: 'Problema de calidad del producto',
      3: 'No se envió dentro del tiempo acordado',
      5: 'Otras razones',
    },
    returnReasonSelect: 'Seleccionar razón de devolución',
    returnExplain: 'Instrucciones de devolución',
    residueReturnNumTips: 'Derechos de devolución de servicio gratuito restantes este mes',
    returnTips:
      'Verificación final de la devolución debido al vendedor o la plataforma, acbuy reembolsará el costo de envío que usted asume.',
    changeTips:
      'Para devoluciones o cambios debido a razones del vendedor, es posible que aún deba asumir parte del costo de envío del cambio.',
    returnTip4: 'Recordatorio amistoso',
    returnTip5:
      'El servicio de devolución y cambio establecerá un número de veces de servicio de operación gratuito. (Cada usuario puede solicitar la devolución o cambio de mercancías sin cargo de servicio de operación por primera vez cada mes, mientras que el costo de envío generado por la devolución o cambio de mercancías se negocia entre el agente y el vendedor y se cobra por acbuy.) Tarifa de servicio de devolución y cambio de acbuy: 5 Yuan/pedido',
    returnTip10:
      'Si la devolución o el cambio es responsabilidad del agente de compras, el vendedor o la plataforma, el sistema reembolsará estos 5 Yuan de tarifa de operación a su cuenta de saldo de acbuy.',
  },
  holder: {
    selectCancelReason: 'Por favor, seleccione la razón de retiro',
    inputOtherReason: 'Por favor, ingrese la razón',
    inputSearchHint: 'Nombre/Número de pedido/Número de producto',
    inputCancelReason: 'Por favor, ingrese la razón para cancelar el pedido',
  },
  selectProducts: 'Seleccionar productos',
  confirmStepOrder: 'Confirmar pedido',
  PayForProducts: 'Pagar por los productos',
  sendingPackages: 'Envío de paquetes',
  submitDelivery: 'Enviar para entrega',
  readAgreeText: 'He leído y estoy de acuerdo',
  disclaimer: 'Renuncia de responsabilidades',
  orderNote:
    'Nota: Una vez completado el pago, deberá enviar el paquete para el envío internacional una vez que el pedido llegue y se almacene en el almacén.',
  goPay2: 'Pago adicional',
  backTax: 'Pagar adicional',
  reminder: 'Recordatorio',
  disclaimer1: 'Descripción de artículos prohibidos',
  disclaimer2: 'Términos de servicio',
  disclaimer3: 'Política de devolución',
  customPhotosTips:
    'Una fotografía proporciona solo un requisito detallado para fotografiar un artículo',
  backCartEdit: 'Volver a la modificación del carrito',
  customPhotosReminderLabel: 'Atención',
  customPhotosReminder:
    'Una foto solo proporciona un requisito detallado para tomar una foto de un producto',
  packageAgreeTip1:
    '1. Los retrasos, daños, pérdidas, impuestos, confiscaciones y otras incertidumbres relacionadas con los servicios del proveedor de logística están fuera de nuestro control y no nos haremos responsables de ninguna responsabilidad resultante. Sin embargo, haremos todo lo posible para recordarle que piense bien antes de realizar una compra, le ayudaremos a resolver cualquier problema con el proveedor de logística y le compensaremos de acuerdo con la política de postventa proporcionada por el proveedor de logística.',
  packageAgreeTip2:
    '2. Recomendamos que declare correctamente su paquete. Si su paquete se somete a inspecciones aleatorias durante el desembolso aduanero en el país de destino, es posible que deba pagar algunos impuestos. Si recibe una notificación de impuestos, pague los impuestos correspondientes; de lo contrario, puede enfrentar consecuencias como el pago de altas tarifas de devolución y la destrucción del paquete.',
  applyRefund: 'Solicitar reembolso',
  refundReminder:
    'Consejo: Después de solicitar un reembolso, el comprador verificará el estado del producto y no podrá cancelar la solicitud de reembolso antes de verificarla.',
  inputApplyReason: 'Por favor, ingrese la razón de la solicitud',
  orderConfirm: 'Confirmar pedido',
  replyMsg: 'Mensaje de respuesta',
  replyMsgTips:
    'Información de nota que envía, le notificaremos al comprador para que lo verifique.',
  shoppingOrder: 'Pedidos de compra',
  transportOrder: 'Pedidos de envío de paquetes',
  choosePlatform: 'Elegir una plataforma',
  selectTargetCountry: 'Elegir país de destino',
  selectCountryTips:
    'Por favor, elija/rellene su país de destino para que acbuy pueda distinguir si el artículo se puede enviar o no.',
  pleaseSelectOrder: 'Por favor, seleccione pedidos en la misma moneda para el liquidación',
  canNotStorageTip:
    'El producto ha estado en almacén por más de 5 días y no puede ser devuelto ni cambiado.',
  purchaseService: 'Servicios de adquisición',
  refundProgress: 'En proceso de reembolso',
  returnChangeTip:
    'Nota: Si el producto presenta pequeños problemas de calidad (marcas de pegamento, imperfecciones, manchas), es posible que el vendedor no se haga cargo de los costos de envío de devolución. ¡En ese momento, deberás asumir los gastos de envío tú mismo!',
  goodNumTip:
    'Nota: Cuando la cantidad de compra del mismo producto sea mayor o igual a 10 piezas, para mejorar la eficiencia del almacenamiento, los inspectores de calidad solo realizarán inspecciones de calidad en el 20% de sus productos. Sin embargo, todos los colores, estilos y tamaños del producto se verificarán para usted, ¡gracias por su comprensión!',
  'i18n-0000001': 'Video Personalizado',
  'i18n-0000002': 'Descripción del servicio',
  'i18n-0000003':
    'Se grabará un video del producto de entre 20 y 90 segundos (la duración puede variar según el producto), ofreciendo a los usuarios un servicio de inspección en video personalizado.',
  'i18n-0000004':
    'Nota: Activar productos electrónicos o digitales puede anular el servicio postventa. La plataforma no se hace responsable.',
  'i18n-0000005':
    'Actualmente hay rutas de envío limitadas disponibles para el país de destino seleccionado. Le recomendamos utilizar la herramienta de estimación de gastos de envío antes de realizar su pedido, o añadir los artículos al carrito y usar la función Estimación de Envío para evitar costes de envío elevados debido a las limitaciones de ruta.',
  'i18n-0000006': 'Rutas de entrega al país de destino: {lineNum}',
  buyAgain: 'Comprar de nuevo',
  remindShop: 'Recordar el envío',
}
